<div class="passengers-container">
  <div class="passenger-buttons">
    @for(passenger of passengers; track passenger){

    <button
      (click)="togglePassenger(passenger.id_passenger.toString())"
      [class.selected]="isSelected(passenger.id_passenger.toString())"
      [class.unselected]="!isSelected(passenger.id_passenger.toString())"
    >
      {{ passenger.name }} {{ passenger.surname }}
    </button>
    }
  </div>
</div>
